import { computed, reactive } from 'vue';

const loadingState = reactive({
  pending: 0
});

export const isGlobalLoading = computed(() => loadingState.pending > 0);

export function startGlobalLoading() {
  loadingState.pending += 1;
}

export function stopGlobalLoading() {
  loadingState.pending = Math.max(0, loadingState.pending - 1);
}

export default loadingState;
